import en from './en';
import pt from './pt';

const messages = {
    en,
    pt,
};

export default messages;
